/**
 * BagFast — Main JavaScript
 * Shopify Online Store 2.0 Theme
 */
(function () {
  'use strict';

  /* ========== Header scroll state ========== */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ========== Mobile drawer ========== */
  const hamburger = document.querySelector('[data-mobile-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-mobile-overlay]');
  const drawerClose = document.querySelector('[data-mobile-close]');

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    hamburger && hamburger.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    hamburger && hamburger.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ========== Accordions ========== */
  document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var content = this.nextElementSibling;
      if (!content) return;

      if (expanded) {
        this.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0';
      } else {
        this.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  /* ========== Carousel controls ========== */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;

    var scrollAmount = 300;

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  });

  /* ========== Quick-add form (Ajax) ========== */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-quick-add-form]')) return;
    e.preventDefault();

    var data = new FormData(form);
    var body = {
      items: [
        {
          id: parseInt(data.get('id'), 10),
          quantity: parseInt(data.get('quantity') || '1', 10),
        },
      ],
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        // Refresh cart and open drawer
        if (window.BagFastCart) window.BagFastCart.refresh();
      })
      .catch(function (err) {
        console.error('Quick-add error:', err);
      });
  });

  /* ========== Quantity selectors ========== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;

    var container = btn.closest('[data-qty-selector]');
    if (!container) return;

    var display = container.querySelector('[data-qty-value]');
    if (!display) return;

    var val = parseInt(display.textContent, 10) || 1;
    var direction = btn.getAttribute('data-qty-btn');

    if (direction === 'minus' && val > 1) {
      display.textContent = val - 1;
    } else if (direction === 'plus') {
      display.textContent = val + 1;
    }

    // Update hidden input if present
    var input = container.querySelector('input[name="quantity"]');
    if (input) input.value = display.textContent;
  });

  /* ========== Product variant selectors ========== */
  document.querySelectorAll('[data-variant-option]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = this.closest('.variant-group__options');
      if (!group) return;

      group.querySelectorAll('[data-variant-option]').forEach(function (el) {
        el.classList.remove('is-active');
      });
      this.classList.add('is-active');
    });
  });

  /* ========== Sticky Add-to-Cart (Mobile) ========== */
  var stickyATC = document.querySelector('.sticky-atc');
  var productActions = document.querySelector('.product-info__actions');

  if (stickyATC && productActions) {
    var atcObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyATC.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    atcObserver.observe(productActions);
  }

  /* ========== Animate on scroll ========== */
  var animateEls = document.querySelectorAll('[data-animate]');
  if (animateEls.length > 0 && 'IntersectionObserver' in window) {
    var animObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            animObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    animateEls.forEach(function (el) {
      animObserver.observe(el);
    });
  }
})();
